export default "__VITE_ASSET__9feb7242__"